import React from 'react';
import cn from 'classnames';

import { i18n } from '@lt/localization';

import Popup from '../../../../components/Popup';
import OrderError from './Errors/OrderError';

import type { PropsFromRedux } from '.';
import type { IErrorPopup } from './types';
import { ERROR_TYPE } from '../../store/domains/error/constants';

const baseCls = 'lt-error-popup';

export const ErrorPopup = ({
  isOpened,
  closePopup,
  message = i18n.t('checkout.error.unknown'),
  type = null,
  orderId = null,
  goToOrder,
  isOrderCreated,
  isMobile,
  partnerContactPhone,
}: PropsFromRedux & IErrorPopup): JSX.Element => {
  const { t } = i18n;

  const isTypeOrder =
    type === ERROR_TYPE.ORDER || type === ERROR_TYPE.ORDER_3DS;

  const errorContent = isTypeOrder ? (
    <OrderError
      title={t('checkout.error.writeOff')}
      errorMessage={message || ''}
      partnerContactPhone={partnerContactPhone}
      onClickRetry={closePopup}
      orderNumber={orderId ?? ''}
      showOrderLink={isOrderCreated}
      goToOrder={goToOrder}
    />
  ) : (
    <div className={`${baseCls}__content`}>
      <div className="lt-icon-error">
        <i className="lt-icon-error__cross" />
      </div>
      <h2 className={`${baseCls}__title`}>{t('checkout.error.title')}</h2>
      <div className={`${baseCls}__message`}>
        <p>
          <strong>{t('checkout.error.possibleReasons')}</strong>
        </p>
        {message}
      </div>
    </div>
  );

  return (
    <Popup
      classNames={{
        modal: cn(baseCls, {
          [`${baseCls}--mobile`]: isMobile,
        }),
        closeButton: 'lt-modal-popup__close',
        overlay: `${baseCls}__overlay`,
      }}
      open={isOpened}
      onClose={closePopup}
      closeOnEsc
      closeOnOverlayClick
      showCloseIcon
    >
      {errorContent}
    </Popup>
  );
};
